import React from "react";
import "./Blog.css";
import { FaCalendarAlt } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";


const blogs = [ 
  {
    id: 1, 
    title: "Top 10 Places to Visit in Hyderabad", 
    description: "Discover the must-visit attractions in Hyderabad, from Charminar to Ramoji Film City. Perfect for travelers planning a short or long trip.", 
    image: "https://images.unsplash.com/photo-1603262110263-fb0112e7cc33", 
    date: "Aug 28, 2025", 
    link: "#", 
  }, 
  { 
    id: 2, 
    title: "Why Choose Cab Rentals in Hyderabad?", 
    description: "Explore the benefits of choosing cab and bus rentals in Hyderabad for comfortable and safe journeys within the city and beyond.", 
    image: "/Images/hyd-tempo.jpg", 
    date: "Aug 21, 2025", 
    link: "#", 
  }, 
  { 
    id: 3,
    title: "Best Weekend Getaways from Hyderabad",
    description: "Planning a quick escape from the city? Check out these amazing weekend getaway spots within driving distance of Hyderabad.", 
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRS2NTrn_vjbKYgoF9vbHaYThOCvyVlT2zhug&s",
    date: "Aug 10, 2025",
    link: "#", 
  },
  { 
    id: 4,
    title: "Affordable Tempo Traveller Rentals in Hyderabad", 
    description: "Traveling with a group? Tempo Traveller rentals in Hyderabad are the perfect solution for comfortable and budget-friendly journeys.", 
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRY8DcqwFGoeEQLzdD9DQaCTR53CKOodiJqwA&s",
    date: "July 29, 2025", link: "#", 
  },
  {
    id: 5,
    title: "Tips for Hassle-Free Bus Rentals in Hyderabad",
    description: "From choosing the right bus size to understanding rental policies, here’s everything you need to know for a smooth bus rental experience.", 
    image: "https://minibusrentinhyderabad.com/wp-content/uploads/2024/02/2018040958271_Executive-LX-Coach2-2.jpg",date: "July 15, 2025", 
    link: "#",
  },
  { 
    id: 6, 
    title: "Hyderabad Airport Transfers Made Easy",
    description: "Book reliable cab rentals for Hyderabad airport transfers. Say goodbye to last-minute stress and enjoy on-time pickups and drop-offs.",
    image: "https://images.unsplash.com/photo-1529070538774-1843cb3265df", 
    date: "July 2, 2025",
    link: "#", 
  }, 
];

const Blog = () => {
  return (
    <div className="blog-Main-page">

      {/* Blog Slider Section */}
      <div className="blog-Main-slider">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
          spaceBetween={20}
          slidesPerView={1}
        >
          {blogs.map((blog) => (
            <SwiperSlide key={blog.id}>
              <div className="blog-Main-slide-card">
                <img src={blog.image} alt={blog.title} className="blog-Main-slide-image" />
                <div className="blog-Main-slide-content">
                  <h3>{blog.title}</h3>
                  <p>{blog.description}</p>
                  <a href={blog.link} className="blog-Main-read-more-btn">
                    Read More →
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div>
        <h2 className="blog-Main-heading">Our Latest Blogs</h2>
        <p className="blog-Main-subheading">
          Travel tips, guides, and insights for your Hyderabad journeys.
        </p>
      </div>

      {/* Blog Grid Section */}
      <div className="blog-Main-grid">
        {blogs.map((blog) => (
          <div key={blog.id} className="blog-Main-card">
            <div className="blog-Main-image-container">
              <img src={blog.image} alt={blog.title} className="blog-Main-image" />
              <span className="blog-Main-date">
                <FaCalendarAlt /> {blog.date}
              </span>
            </div>

            <div className="blog-Main-content">
              <h3>{blog.title}</h3>
              <p>{blog.description}</p>
              <Link to={`/blogs/${blog.id}`} className="blog-Main-read-more-btn">
                Read More →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
